import PubSub from "underpub-js";

var Carousel = function (options) {

  this.options = {
    $el: false,
    baseClass: 'el-Carousel',
  };

  $.extend(true, this.options, options);

};

Carousel.prototype.init = function () {
  var self = this;

  self.$slides = self.options.$el.find(`.${self.options.baseClass}__slides`);
  self.$arrows = self.options.$el.find(`.${self.options.baseClass}__arrows`);
  self.$prevArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$nextArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

  PubSub.subscribe('Carousel:updateData', data => {
    if (!data) return;

    self.updateData(data);
  });

  self.initSlider(self.options.$el);
};

Carousel.prototype.initSlider = function ($carousel) {
  const self = this;

  if (!$carousel.length) return;

  const $slide = $carousel.find(`.${self.options.baseClass}__slide`);
  const $slides = $carousel.find(`.${self.options.baseClass}__slides`);
  const $arrows = $carousel.find(`.${self.options.baseClass}__arrows`);

  if ($slide.length > 1) {
    $arrows.show();

    $slides.slick({
      prevArrow: self.$prevArrow,
      nextArrow: self.$nextArrow,
      swipe: true,
    });
  }
}

Carousel.prototype.resetSlider = function ($carousel) {
  const self = this;

  if (!$carousel.length) return;

  const $slides = $carousel.find(`.${self.options.baseClass}__slides`);

  if ($slides.hasClass('slick-initialized')) {
    $slides.slick('unslick');
  }

  $slides.hide().empty();
}

Carousel.prototype.updateData = function (data) {
  const self = this;
  const container = data.container;
  const slides = data.slides;
  const reset = data.reset;

  if (!container || !container.length) return;

  if (self.options.$el.parent($(container)).length) {
    const $carousel = $(container).find(self.options.$el);

    if (!$carousel.length) return;

    if (reset) {
      self.resetSlider($carousel);
      return;
    }

    if (slides && slides.length) {
      self.updateSlides($carousel, slides);
    }
  }
}

Carousel.prototype.updateSlides = function ($carousel, slides) {
  const self = this;

  if (!slides || !$carousel) return;

  const $slides = $carousel.find(`.${self.options.baseClass}__slides`);

  $slides.hide().empty();

  if ($slides.hasClass('slick-initialized')) {
    $slides.slick('unslick')
  }

  slides.forEach(slide => {
    const slideType = slide.type;

    if (!slideType || !slideType.length) return;

    let slideElement;

    switch (slideType) {
      case "image":
        slideElement = self.createImageSlide(slide);
        break;
      case "video":
        slideElement = self.createVideoSlide(slide);
        break;
      default:
        break;
    }

    if (slideElement && slideElement.length) {
      $slides.append(slideElement);
    }
  });

  $slides.show();
  self.initSlider($carousel);
}

Carousel.prototype.createImageSlide = function (data) {
  const self = this;

  if (!data) return;

  const url = data.url;
  const alt = data.alt;

  if (!url || !url.length) return;

  const slide = `<div class="${self.options.baseClass}__slide">
    <div class="${self.options.baseClass}__image" style="background-image: url(${url})">
      <div class="${self.options.baseClass}__image__inner">
        <img class="atom-HiddenImage" src="${url}" alt="${alt}" />
      </div>
    </div>
  </div>`;

  return slide;
}

Carousel.prototype.createVideoSlide = function (data) {
  const self = this;

  if (!data) return;

  const url = data.url;

  if (!url || !url.length) return;

  const slide = `<div class="${self.options.baseClass}__slide">
    <div class="${self.options.baseClass}__video">
      <div class="${self.options.baseClass}__video__inner">
        <iframe type="text/html" src="${url}" frameborder="0" allow="autoplay"></iframe>
      </div>
    </div>
  </div>`;

  return slide;
}

export default Carousel;